import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, TextField, Button, Typography, TableFooter } from '@mui/material';
import isGHMC, { formatDayMonthYearTime, getCurrentDate, getCurrentDateTime, getStartOfCurrentDate } from '../../../Common/helper/helpar';
import ExcelJS from "exceljs";
import axiosInstance from '../../../../Hooks/axoisInstance';
import CreatableSelect from 'react-select/creatable';
import { AllTertiaryDeploymentReport } from '../../../Apis/userCreationApi';
import { AllVehicleDetails, AllVehicleTypeDetails } from '../../../Apis/vehicleApi';
import { AllDriverDetails } from '../../../Apis/driverApi';
import { AllOwnerTypeDetails } from '../../../Apis/ownerTypeApi';

const TertiaryDeploymentReport = () => {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [orderDirection, setOrderDirection] = useState("asc");
  const [vehicleNumber, setVehicleNumber] = useState('');
  const [selectedDriver, setSelectedDriver] = useState('');
  const [vehicleList, setVehicleList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [VehicleNumberDetails, setVehicleNumberDetails] = useState([]);
  const [driverNameDetails, setDriverNameDetails] = useState([]);
  const [driver, setDriver] = useState('');
  const [optionsValues, setOptionsValues] = useState([]);
  const [driverOptionTeritary, setDriverOptionTeritary] = useState([]);
  const [optionsVehicleValues, setOptionVehicleValues] = useState([]);
  const [optsVehicle, setOptsVehicle] = useState(optionsVehicleValues);
  const [optionsDrivervalues, setOptionDriverValues] = useState([]);
  const [optsDriver, setOptsDriver] = useState(optionsDrivervalues);
  const [selectedVehicle, setSelectedVehicle] = useState([]);
  const [page, setPage] = useState(0);
  const [sortConfig, setSortConfig] = useState(null);
  const [sortedData, setSortedData] = useState([]);
  const [selectedVehilceNo, setSelectedVehicleNo] = useState([]);
  const [vehicleNo, setVehicleNo] = useState([]);
  const [driverName, setDriverName] = useState([]);
  const [selectedDriverName, setSelectedDriverName] = useState([]);
  const [selectedVehilceNoCircle, setSelectedVehicleNoCircle] = useState([]);
  const isProd = isGHMC();
  const [originalData, setOriginalData] = useState([]);
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [vehicleTypeOptionsValues, setVehicleTypeOptionsValues] = useState([]);
  const [optionsLoadingValues, setOptionLoadingValues] = useState([]);
  const [selectedOwnerType, setSelectedOwnerType] = useState([]);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [selectedVehicleType, setSelectedVehicleType] = useState([]);
  const getToken = () => {
    return localStorage.getItem("token");
  };
  // Fetch data from API

  useEffect(() => {
    const fetchOwnerTypeData = async () => {
      try {
        const ownerTypeData = await AllOwnerTypeDetails();
        setOwnerTypeDetails(ownerTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };
    console.log(selectedOwnerType, 'selectedowner')
    fetchOwnerTypeData();
  }, [selectedOwnerType]);

  useEffect(() => {
    const fetchVehicleTypeData = async () => {
      try {
        const vehicleTypeData = await AllVehicleTypeDetails();
        setVehicleTypeDetails(vehicleTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchVehicleTypeData();
  }, []);


  useEffect(() => {
    setOptionsValues(ownerTypeDetails
      .filter((ownerType) => ownerType.isActive)
      .map(ownerType => ({
        value: ownerType.ownerTypeId,
        label: ownerType.ownerTypeName,
      })));
  }, [ownerTypeDetails]);

  useEffect(() => {
    setVehicleTypeOptionsValues(vehicleTypeDetails.map(vehicleType => ({
      value: vehicleType.vehicleTypeId,
      label: vehicleType.vehicleTypeName,
    })));
  }, [vehicleTypeDetails]);

  const handleOwnerChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedOwnerType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedOwnerType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedOwnerType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };
  const handleVehicleTypeChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedVehicleType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedVehicleType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedVehicleType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };

  const fetchData = async (filters = {}) => {
    const queryParams = new URLSearchParams(filters).toString();
    try {
      const data = await AllTertiaryDeploymentReport(queryParams)
      // Check if data exists and update state
      if (data && data.length > 0) {
        setRows(data); // Store data in rows
        setFilteredRows(data); // Initially, filteredRows are the same as rows
        console.log(data, 'filtered rows');
      } else {
        setRows([]); // Clear rows if no data
        setFilteredRows([]); // Clear filteredRows
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };



  useEffect(() => {
    const defaultFilters = {
      startDateTime: startDate || '',
      endDateTime: endDate || '',
      VehicleNumber: vehicleNo || '',
      DriverName: driverName || '',
      VehicleTypeId: selectedVehicleType || '',
      OwnerTypeId: selectedOwnerType || ''
    };
    fetchData(defaultFilters); // Call API with default filters on mount
  }, []);

  // Filter rows based on date range
  const handleFilter = () => {
    const filters = {
      startDateTime: startDate || '',
      endDateTime: endDate || '',
      VehicleNumber: vehicleNo || '', // Use vehicle ID
      DriverName: driverName || '', // Use driver ID
      VehicleTypeId: selectedVehicleType || '',
      OwnerTypeId: selectedOwnerType || ''
    };
    console.log(filters)
    fetchData(filters);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const downloadAsExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Tertiary Deployment");

    // Define styles
    const boldFont = { bold: true };

    // Get current date and time
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Tertiary Deployment Report Generated on: ${formattedDate}, ${formattedTime}`;

    // Add the downloadDateTime to the worksheet
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 12);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Add report title
    worksheet.addRow(["", "", "Tertiary Deployment Report", ""]);
    worksheet.mergeCells(2, 2, 2, 12);
    worksheet.getCell(2, 2).value = "Tertiary Deployment Report";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 12).alignment = { horizontal: "center" };

    // Define table headers
    const tableHeaderRow = worksheet.addRow([
        "S.No", "Driver Name", "Driver Code", "Vehicle Number", "Vehicle Type","Owner Type",
        "Deployment Location", "Destination Station", "Shift ID", "Deployment Date & Time",
        "Latitude", "Longitude", "Is Deviated", "Deviation Distance", "Status"
    ]);
    
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = boldFont;
        cell.alignment = { horizontal: "left" };
        if (colNumber >= 1 && colNumber <= 15) {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "F6B1B1" },
                bgColor: { argb: "FFFFFFFF" }
            };
        }
    });

    // Add data rows
    let totalDeviationDistance = 0; // Variable to track total deviation distance

    filteredRows.forEach((item, index) => {
      const deviationDistance = item.deviationDistance ? (item.deviationDistance / 1000).toFixed(2) : 0; // Convert to km
      totalDeviationDistance += deviationDistance;
      

        worksheet.addRow([
            index + 1, 
            item.driverName?? "N/A", item.driverCode?? "N/A", item.vehicleNumber?? "N/A", item.vehicleTypeName?? "N/A",item.ownerTypeName?? "N/A",
            item.deploymentLocation?? "N/A", item.destinationLocation?? "N/A", item.shiftId?? "N/A", item.deploymentDateTime?? "N/A",
            item.latitude?? "N/A", item.longitude?? "N/A", item.isDeviated?? "N/A", deviationDistance, item.status|| "N/A"
        ]).eachCell({ includeEmpty: true }, (cell) => {
            cell.alignment = { horizontal: "left" };
        });
    });
    const formattedTotalDeviationDistance = filteredRows
    .reduce((sum, row) => sum + (row.deviationDistance ? row.deviationDistance / 1000 : 0), 0)
    .toFixed(2);
  
    const totalRow = worksheet.addRow([
        "", "", "", "", "", "", "", "", "", "", "","", "Total", formattedTotalDeviationDistance, ""
    ]);

    totalRow.eachCell({ includeEmpty: true }, (cell) => {
        cell.font = boldFont;
        cell.alignment = { horizontal: "left" };
    });

    // Set column widths dynamically
    worksheet.columns = [
        { width: 5 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 },
        { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 },
        { width: 20 }, { width: 20 }, { width: 20 },{ width: 20 }, { width: 20 }
    ];

    // Save the workbook to a file
    try {
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "TertiaryDeploymentReport.xlsx";
        a.click();
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error generating Excel file:", error);
    }
};


  const handleSort = (column) => {
    const isAsc = orderDirection === "asc";
    const sorted = [...sortedData].sort((a, b) => {
      const valueA = a[column] ? a[column].toString() : ''; // Convert to string if not undefined
      const valueB = b[column] ? b[column].toString() : ''; // Convert to string if not undefined
      return isAsc ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });
    setSortedData(sorted);
    setOrderDirection(isAsc ? "desc" : "asc");
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  return (
    <div>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">Tertiary Deployment Report</h4>
            <div className="card">
              <div className="card-body p-3">

                <div className="row align-items-end" style={{ textAlign: "left" }}>
                  <div className="col-md-2">
                    <label>Start Date</label>
                    <input
                      label="Start Date"
                      type="datetime-local"
                      className="form-control"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      max={endDate ? endDate : getCurrentDateTime()}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>End Date</label>
                    <input
                      label="End Date"
                      type="datetime-local"
                      value={endDate}
                      className="form-control"
                      onChange={(e) => setEndDate(e.target.value)}
                      min={startDate}
                      max={getCurrentDateTime()}
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="ownerType">Owner Type:</label>
                    <CreatableSelect
                      classNamePrefix="CreatableSelect"
                      inputId="ownerType"
                      name="ownerTypeId"
                      id="ownerType"
                      placeholder="Select"
                      options={optionsValues}
                      isClearable={true}
                      onChange={handleOwnerChange}
                      onCreateOption={(inputValue) => {
                        const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                        if (inputValue) {
                          setSelectedOwnerType(newValue.value);
                          setOptionsValues((prevOptions) => [...prevOptions, newValue]);
                        } else {
                          setSelectedOwnerType("");
                        }
                      }}
                      value={optionsValues.find((option) => option.value === selectedOwnerType)}
                    //  className="hidden-select" // Apply the custom class here
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="VehicleType">Vehicle Type:</label>
                    <CreatableSelect style={{ Height: '34px !important' }}
                      classNamePrefix="CreatableSelect"
                      inputId="vehicleType"
                      name="vehicleTypeId"
                      id="vehicleType"
                      placeholder="Select"
                      options={vehicleTypeOptionsValues}
                      isClearable={true}
                      onChange={handleVehicleTypeChange}
                      onCreateOption={(inputValue) => {

                        const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                        { inputValue && newValue ? (setSelectedVehicleType(newValue.value)) : setSelectedVehicleType("  "); }
                        // setSelectedOwnerType(newValue.value);
                        // Add logic to update optionsValues with the new option if needed
                      }}
                      value={vehicleTypeOptionsValues.find((option) => option.value === selectedVehicleType)}
                    />
                  </div>
                  <div className="col-md-2">
                    <div className="form-group-filter">
                      <label >Vehicle Number</label>
                      <input
                        type="text"
                        className="form-control"
                        value={vehicleNo}
                        // id="vehicle-filter-input" 
                        placeholder='Enter Vehicle Number'
                        onChange={(e) => setVehicleNo(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group-filter">
                      <label >Driver Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={driverName}
                        onChange={(e) => setDriverName(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        sx={{ marginRight: '30px' }}
                        placeholder='Enter Driver Name'
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className='d-flex justify-content-end align-items-end'>
                      <button variant="contained" className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                        onClick={handleFilter} sx={{ padding: '10px 20px' }}>
                        Search
                      </button>
                      <button
                        className="btn btn-excel"
                        onClick={downloadAsExcel}
                      >
                        <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                      </button>
                    </div>
                  </div>
                </div>

                <div className='table-responsive'>
                  <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '20px' }}>
                    <TableContainer
                      component={Paper}
                      sx={{
                        width: '100%',
                        maxHeight: '500px',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead
                          sx={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 0, // Ensure header stays above other content
                            overflow: 'auto'
                          }}
                        >
                          <TableRow sx={{ paddingTop: '20px' }}>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '15px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>S.No</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '15px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Driver Name</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Driver Code</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Vehicle Number</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Vehicle Type</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Owner Type</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Deployment Location</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Destination Station</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Shift ID</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Deployment Date & Time</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Latitude</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Longitude</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Is Deviated</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Deviation Distance(km)</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }}>Status</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {filteredRows.length > 0 ? (
                            filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              .map((row, index) => (
                                <TableRow
                                  key={row.sno}
                                  sx={{
                                    backgroundColor: isProd
                                      ? index % 2 === 0
                                        ? '#8fc9ff'
                                        : '#aed8ff'
                                      : index % 2 === 0
                                        ? '#F8CCCD'
                                        : '#ffeded',
                                    '&:nth-of-type(odd)': { backgroundColor: isProd ? '#aed8ff' : '#ffeded' },
                                    '&:nth-of-type(even)': { backgroundColor: isProd ? '#8fc9ff' : '#F8CCCD' },
                                  }}
                                >
                                  <TableCell sx={{ textAlign: 'center', padding: '10px', border: '1px solid #ddd', borderRight: 'none', }}>
                                    {row.sno || index + 1}
                                  </TableCell>

                                  <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', }}>{row.driverName}</TableCell>
                                  <TableCell sx={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', borderRight: 'none', }}>{row.driverCode || 'N/A'}</TableCell>
                                  <TableCell sx={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', borderRight: 'none', }}>{row.vehicleNumber || 'N/A'}</TableCell>
                                  <TableCell sx={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', borderRight: 'none', }}>{row.vehicleTypeName || 'N/A'}</TableCell>
                                  <TableCell sx={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', borderRight: 'none', }}>{row.ownerTypeName || 'N/A'}</TableCell>
                                  <TableCell sx={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', borderRight: 'none', }}>{row.deploymentLocation || 'N/A'}</TableCell>
                                  <TableCell sx={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', borderRight: 'none', }}>{row.destinationLocation || 'N/A'}</TableCell>
                                  <TableCell sx={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', borderRight: 'none', }}>{row.shiftId || 'N/A'}</TableCell>
                                  <TableCell sx={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', borderRight: 'none', }}>
                                    {row.deploymentDateTime
                                      ? formatDayMonthYearTime(row.deploymentDateTime)
                                      : 'N/A'
                                    }
                                  </TableCell>
                                  <TableCell sx={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', borderRight: 'none', }}>{row.latitude || 'N/A'}</TableCell>
                                  <TableCell sx={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', borderRight: 'none', }}>{row.longitude || 'N/A'}</TableCell>
                                  <TableCell sx={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', borderRight: 'none', }}>{row.isDeviated || 'N/A'}</TableCell>
                                  <TableCell sx={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', borderRight: 'none', }}>{(row.deviationDistance / 1000).toFixed(2) || 'N/A'}</TableCell>
                                  <TableCell sx={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center', borderRight: 'none', }}>{row.status || 'N/A'}</TableCell>
                                </TableRow>
                              ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={17} sx={{ textAlign: 'center' }}>No data available</TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                        {filteredRows.length > 0 && (
                        <TableFooter>
                          <TableRow sx={{ backgroundColor: 'rgb(255, 237, 238)', fontWeight: 'bold' }}>
                            <TableCell sx={{ textAlign: 'center', color: 'black' }} ></TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}></TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}></TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}></TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}></TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}></TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}></TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}></TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}></TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}></TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}></TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}></TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}>Total</TableCell>
                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}>
                              {filteredRows.reduce((sum, row) => sum + (row.deviationDistance ? row.deviationDistance / 1000 : 0), 0).toFixed(2)}
                            </TableCell>

                            <TableCell sx={{ textAlign: 'center', border: '1px solid #ddd', color: 'black' }}></TableCell> {/* Deployment % cannot be summed directly */}
                          </TableRow>
                        </TableFooter>
                        )}
                      </Table>
                    </TableContainer>
                    <TablePagination
                      component="div"
                      count={filteredRows.length}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      sx={{
                        alignItems: 'center',
                        justifyContent: 'space-between '
                      }}
                    />
                  </Paper>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TertiaryDeploymentReport;

const inputStyle2 = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  // padding: "15px",
  borderRadius: "0px",
};